import getCookie from './getCookie'

export const setDataLayer = (key: string): void => {
  const incomingUserId = getCookie(key)
  const dataLayerObj = (window as any).dataLayer || []
  if (!incomingUserId && dataLayerObj) {
    const crypto = window?.crypto
    const cryptoArray = new Uint32Array(1)
    const randomValue = crypto?.getRandomValues(cryptoArray)
    dataLayerObj.push({
      user_id: Math.floor(Number(randomValue) * 100),
    })
  }
}
